var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2294 8.84863V10.346C10.8357 10.3658 10.424 10.3766 10 10.3766C9.53939 10.3766 9.09358 10.364 8.66946 10.3404V9.14487H8.6692V8.85322C6.31641 8.96646 4.57471 9.37329 4.57471 9.8579C4.57471 10.4304 7.00369 10.8941 10.0001 10.8941C12.9963 10.8941 15.4255 10.4304 15.4255 9.8579C15.4254 9.36614 13.6333 8.9549 11.2294 8.84863Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47724 0 0 4.47698 0 9.99991C0 15.5226 4.47724 20 10 20C15.5228 20 19.9999 15.5226 19.9999 9.99991C19.9999 4.47698 15.5227 0 10 0ZM11.2292 11.6977V16.1087H8.6691V11.6917C5.92853 11.5331 3.87842 10.8957 3.87842 10.133C3.87842 9.37049 5.92853 8.73312 8.6691 8.57429V7.33828H5.18384V4.77824H14.7148V7.33828H11.2292L11.2294 8.56838C14.021 8.7169 16.1218 9.36114 16.1218 10.133C16.1217 10.905 14.021 11.5494 11.2292 11.6977Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtIcon);
export default __webpack_public_path__ + "static/media/USDTIcon.82374c45104b2f8d82ccf5eae2033080.svg";
export { ForwardRef as ReactComponent };